import { toKebabCase } from './helperFunctions'


export const getFormattedSeoUrl = ({
                              seoDetails,
                              slug,
                              title,
                              label,
                              name,
                              id,
                              product_id: productId,
                            }) =>
  `${(seoDetails?.slug || slug) ? (seoDetails?.slug ?? slug) : toKebabCase(seoDetails?.title ? seoDetails.title : title ?? name ?? label ?? '')}-${id ?? productId}`

export const getReverseFormattedSeoUrl = (url) => {
  if (!url) return { id: undefined, name: undefined }
  let Url = url?.split('-')
  let id = Url[Url?.length - 1]
  Url.pop()
  return {
    id,
    name: Url.map(w => w.charAt(0).toUpperCase() + w.substring(1).toLowerCase())?.join(' '),
  }
}

export const generateLinkForBlogPage = (blog) =>
  `/blogs/${getFormattedSeoUrl({
    seoDetails: blog.seo_details,
    title: blog.title,
    id: blog.id,
  })}`
